import { axiosCashJournalClient } from "../api";
import { MIDDLE_URL } from "../config";
import {
  IDefaultParams,
  IGetBusinessTrxApiResponse,
  IGetBusinessTrxParams,
  IGetTrxAreaResponse,
  IGetTrxGlListResponse,
  IGetTrxTypeListResponse,
  IGetTrxPoolResponse,
  IGetTrxCompanyResponse,
  IGetTrxDepartmentResponse,
  ICreateMasterBusinessTrxRequest,
  IEditMasterBusinessTrxRequest,
  IGetTrxFilterAreaResponse,
  IGetTrxFilterPoolResponse,
  IGetTrxFilterCompanySegmentResponse,
  IGetTrxDepartmentByCompanyResponse,
  ICompany,
  IResponseMstBusinessTrxData,
} from "./types";

const URL = {
  TRX: {
    LIST: "/v1/smplmsttrxcodeset",
    CODE: {
      LIST: "/v1/msttrxcode",
      GL: {
        LIST: "/v1/msttrxcode/registered-gl",
      },
    },
    POST: "/v1/msttrxcodeset/multiple-assignments",
    PUT: "/v1/msttrxcodeset",
    DELETE: (id: string) => `/v1/msttrxcodeset/${id}`,
    TYPE: "/v1/smplmsttrxtype",
    FILTER: {
      AREA: "/v1/area",
      POOL_BY_AREA: (areaId: string) => `/v1/pool/areaid/${areaId}`,
      COMPANY_BY_POOL_AREA: (areaId: string, poolId: string) => `/v1/smplmstbusiness/codetype/P/areaid/${areaId}/pool_id/${poolId}`,
    },
    DEPARTMENT_BY_COMPANY: "/v1/departmentbycompany",
  },
  BUSINESS: {
    AREA: "/v1/smplmstbusiness/area",
    POOL_BY_AREA: (areas: string) => `/v1/smplmstbusiness/areaid/${areas}/pool`,
    COMPANY_BY_POOL: (pools: string, companies: string) => `/v1/smplmstbusiness/poolid/${pools}/company/${companies}`,
    DEPARTMENT: "/v1/smplmstdepartment",
  },
};

// const baseURL = "http://stg-bbone-fi-simple.internal.bluebird.id";

const getMasterBusinessTrxList = async (params: IGetBusinessTrxParams):
  Promise<IGetBusinessTrxApiResponse> => {
  const response = await axiosCashJournalClient.request({
    method: "GET",
    url: `${MIDDLE_URL}${URL.TRX.LIST}`,
    params,
  });
  return response.data;
};

const getMasterBusinessTrxAllArea = async (): Promise<IGetTrxAreaResponse> => {
  const response = await axiosCashJournalClient.request({
    method: "GET",
    url: `${MIDDLE_URL}${URL.BUSINESS.AREA}`,
  });
  return response.data;
};

const getMasterBusinessTrxPoolByArea = async (areas: string): Promise<IGetTrxPoolResponse> => {
  const response = await axiosCashJournalClient.request({
    method: "GET",
    url: `${MIDDLE_URL}${URL.BUSINESS.POOL_BY_AREA(areas)}`,
  });
  return response.data;
};

const getMasterBusinessTrxCompanyByPool = async (pools: string):
  Promise<IGetTrxCompanyResponse> => {
  const response = await axiosCashJournalClient.request({
    method: "GET",
    url: `${MIDDLE_URL}${URL.BUSINESS.COMPANY_BY_POOL(pools, "-")}`,
  });
  return response.data;
};

const getMasterBusinessTrxSegmentByCompany = async (pools: string, companies: string):
  Promise<IGetTrxCompanyResponse> => {
  const response = await axiosCashJournalClient.request({
    method: "GET",
    url: `${MIDDLE_URL}${URL.BUSINESS.COMPANY_BY_POOL(pools, companies)}`,
  });
  return response.data;
};

const getMasterBusinessTrxAllDepartment = async (): Promise<IGetTrxDepartmentResponse> => {
  const response = await axiosCashJournalClient.request({
    method: "GET",
    url: `${MIDDLE_URL}${URL.BUSINESS.DEPARTMENT}`,
    params: {
      status: "Y",
    },
  });
  return response.data;
};

const getMasterBusinessTrxDepartmentByCompany = async (payload: Pick<ICompany, "company_code" | "company_relation">[]): Promise<IGetTrxDepartmentByCompanyResponse> => {
  const response = await axiosCashJournalClient.request({
    method: "POST",
    url: `${MIDDLE_URL}${URL.TRX.DEPARTMENT_BY_COMPANY}`,
    data: {
      list_company: payload,
    },
  });
  return response.data;
};

const getMasterBusinessTrxGlList = async (params: Pick<IDefaultParams, "page_number" | "search">): Promise<IGetTrxGlListResponse> => {
  const response = await axiosCashJournalClient.request({
    method: "GET",
    url: `${MIDDLE_URL}${URL.TRX.CODE.GL.LIST}`,
    params: {
      search: params.search,
      page_number: params.page_number,
    },
  });
  return response.data;
};

const getMasterBusinessTrxTypeList = async (): Promise<IGetTrxTypeListResponse> => {
  const response = await axiosCashJournalClient.request({
    method: "GET",
    url: `${MIDDLE_URL}${URL.TRX.TYPE}`,
  });
  return response.data;
};

const createMasterBusinessTrx = async (
  payload: ICreateMasterBusinessTrxRequest,
): Promise<IResponseMstBusinessTrxData> => {
  const response = await axiosCashJournalClient.request({
    method: "POST",
    url: `${MIDDLE_URL}${URL.TRX.POST}`,
    data: payload,
  });
  return response.data;
};

const editMasterBusinessTrx = async (
  payload: IEditMasterBusinessTrxRequest,
): Promise<IResponseMstBusinessTrxData> => {
  const response = await axiosCashJournalClient.request({
    method: "PUT",
    url: `${MIDDLE_URL}${URL.TRX.PUT}`,
    data: payload,
  });
  return response.data;
};

const deleteMasterBusinessTrx = async (id: string): Promise<IResponseMstBusinessTrxData> => {
  const response = await axiosCashJournalClient.request({
    method: "DELETE",
    url: `${MIDDLE_URL}${URL.TRX.DELETE(id)}`,
  });
  return response.data;
};

const getMasterBusinessTrxFilterAllArea = async (): Promise<IGetTrxFilterAreaResponse> => {
  const response = await axiosCashJournalClient.request({
    method: "GET",
    url: `${MIDDLE_URL}${URL.TRX.FILTER.AREA}`,
  });
  return response.data;
};

const getMasterBusinessTrxFilterPool = async (areaId: string):
  Promise<IGetTrxFilterPoolResponse> => {
  const response = await axiosCashJournalClient.request({
    method: "GET",
    url: `${MIDDLE_URL}${URL.TRX.FILTER.POOL_BY_AREA(areaId)}`,
  });
  return response.data;
};

const getMasterBusinessTrxFilterCompanySegment = async (areaId: string, poolId: string):
  Promise<IGetTrxFilterCompanySegmentResponse> => {
  const response = await axiosCashJournalClient.request({
    method: "GET",
    url: `${MIDDLE_URL}${URL.TRX.FILTER.COMPANY_BY_POOL_AREA(areaId, poolId)}`,
  });
  return response.data;
};

const getMasterBusinessTrxFilterDepartment = async ():
  Promise<IGetTrxDepartmentResponse> => {
  const response = await axiosCashJournalClient.request({
    method: "GET",
    url: `${MIDDLE_URL}${URL.BUSINESS.DEPARTMENT}`,
    params: {
      status: "Y",
    },
  });
  return response.data;
};

export {
  getMasterBusinessTrxList,
  getMasterBusinessTrxAllArea,
  getMasterBusinessTrxPoolByArea,
  getMasterBusinessTrxCompanyByPool,
  getMasterBusinessTrxSegmentByCompany,
  getMasterBusinessTrxAllDepartment,
  getMasterBusinessTrxGlList,
  getMasterBusinessTrxTypeList,
  createMasterBusinessTrx,
  editMasterBusinessTrx,
  deleteMasterBusinessTrx,
  getMasterBusinessTrxFilterAllArea,
  getMasterBusinessTrxFilterPool,
  getMasterBusinessTrxFilterCompanySegment,
  getMasterBusinessTrxFilterDepartment,
  getMasterBusinessTrxDepartmentByCompany,
};
